import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {getAmplitudeCtaLeadFormTrackingContext} from "../tracking/amplitude/get_amplitude_cta_lead_form_tracking_context";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {
    ApplicationModalOpenTrackingInput,
    isApplicationModalAmplitudeOnlyOpenTracking,
    isApplicationModalOpenTrackingWithAmplitude,
    isGtmEventLeadForm
} from "../types/lead/IApplicationModalOpenTracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (tracking?: ApplicationModalOpenTrackingInput) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
    /** Keeps the button on its own lead form - the unlock choice flow never takes the click over */
    disableUnlockChoice?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, disableUnlockChoice, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const viewType = useAppSelector((state) => state.viewType.current);
    const wasOpenedRef = useRef(false);

    const {startUnlockChoice} = useUnlockChoiceCta();

    const handleOpenModal = useCallback(
        (params: {
            clickText: string;
            source: string;
            amplitudeLeadFormEventTracking: IAmplitudeLeadFormTrackingContext | null;
            gtmEventLeadForm?: IGTMEventLeadForm;
        }) => {
            const {clickText, source, amplitudeLeadFormEventTracking, gtmEventLeadForm} = params;
            const leadModalPayload: MainLeadDataPayload = {
                ...openModalPayload,
                trackingMeta: {
                    openButtonSource: clickText,
                    openButtonSourceText: source
                },
                amplitudeLeadFormEventTracking
            };

            // Reported on the click itself, so that it is sent also when the unlock choice takes the click over
            if (gtmEventLeadForm) {
                gtmEventFormOpen(gtmEventLeadForm.clickText, gtmEventLeadForm.source, gtmEventLeadForm.vendorName, gtmEventLeadForm.offerName);
            }

            if (!disableUnlockChoice && startUnlockChoice({kind: "lead", payload: leadModalPayload, gtmClickText: clickText, gtmSourceSection: source})) {
                return;
            }

            if (openModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
            }

            dispatch(openLeadModal(leadModalPayload));
        },
        [dispatch, openModalPayload, startUnlockChoice, disableUnlockChoice]
    );

    const openModal = useCallback(
        (tracking?: ApplicationModalOpenTrackingInput) => {
            if (!tracking) {
                return;
            }

            if (isApplicationModalAmplitudeOnlyOpenTracking(tracking)) {
                handleOpenModal({
                    clickText: tracking.amplitude.cta_text,
                    source: tracking.amplitude.form_location,
                    amplitudeLeadFormEventTracking: tracking.amplitude
                });
                return;
            }

            if (isApplicationModalOpenTrackingWithAmplitude(tracking)) {
                handleOpenModal({
                    clickText: tracking.gtm.clickText,
                    source: tracking.gtm.source,
                    amplitudeLeadFormEventTracking: tracking.amplitude,
                    gtmEventLeadForm: tracking.gtm
                });
                return;
            }

            if (isGtmEventLeadForm(tracking)) {
                const amplitudeTrackingContext = getAmplitudeCtaLeadFormTrackingContext({
                    source: openModalPayload.source,
                    sourceSection: openModalPayload.sourceSection,
                    leadData: undefined,
                    ctaText: tracking.clickText,
                    offerId: openModalPayload.offerId,
                    propertyId: openModalPayload.propertyId,
                    viewType
                });

                handleOpenModal({
                    clickText: tracking.clickText,
                    source: tracking.source,
                    amplitudeLeadFormEventTracking: amplitudeTrackingContext,
                    gtmEventLeadForm: tracking
                });
            }
        },
        [handleOpenModal, openModalPayload.offerId, openModalPayload.propertyId, openModalPayload.source, openModalPayload.sourceSection, viewType]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {useUnlockChoiceCta} from "../../auth/hooks/use_unlock_choice_cta";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {openLeadModal, setUseAdditionalFormField} from "../state/main_lead_slice";
import {getAmplitudeCtaLeadFormTrackingContext} from "../tracking/amplitude/get_amplitude_cta_lead_form_tracking_context";
import {IAmplitudeLeadFormTrackingContext} from "../types/lead/IAmplitudeLeadFormEventTracking";
import {
    ApplicationModalOpenTrackingInput,
    isApplicationModalAmplitudeOnlyOpenTracking,
    isApplicationModalOpenTrackingWithAmplitude,
    isGtmEventLeadForm
} from "../types/lead/IApplicationModalOpenTracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (tracking?: ApplicationModalOpenTrackingInput) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
    /** Keeps the button on its own lead form - the unlock choice flow never takes the click over */
    disableUnlockChoice?: boolean;
} & Omit<MainLeadDataPayload, "trackingMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, disableUnlockChoice, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.mainLead.isModalOpen);
    const viewType = useAppSelector((state) => state.viewType.current);
    const wasOpenedRef = useRef(false);

    const {startUnlockChoice} = useUnlockChoiceCta();

    const handleOpenModal = useCallback(
        (params: {
            clickText: string;
            source: string;
            amplitudeLeadFormEventTracking: IAmplitudeLeadFormTrackingContext | null;
            gtmEventLeadForm?: IGTMEventLeadForm;
        }) => {
            const {clickText, source, amplitudeLeadFormEventTracking, gtmEventLeadForm} = params;
            const leadModalPayload: MainLeadDataPayload = {
                ...openModalPayload,
                trackingMeta: {
                    openButtonSource: clickText,
                    openButtonSourceText: source
                },
                amplitudeLeadFormEventTracking
            };

            // Reported on the click itself, so that it is sent also when the unlock choice takes the click over
            if (gtmEventLeadForm) {
                gtmEventFormOpen(gtmEventLeadForm.clickText, gtmEventLeadForm.source, gtmEventLeadForm.vendorName, gtmEventLeadForm.offerName);
            }

            if (!disableUnlockChoice && startUnlockChoice({kind: "lead", payload: leadModalPayload, gtmClickText: clickText, gtmSourceSection: source})) {
                return;
            }

            if (openModalPayload.useAdditionalFormField) {
                dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
            }

            dispatch(openLeadModal(leadModalPayload));
        },
        [dispatch, openModalPayload, startUnlockChoice, disableUnlockChoice]
    );

    const openModal = useCallback(
        (tracking?: ApplicationModalOpenTrackingInput) => {
            if (!tracking) {
                return;
            }

            if (isApplicationModalAmplitudeOnlyOpenTracking(tracking)) {
                handleOpenModal({
                    clickText: tracking.amplitude.cta_text,
                    source: tracking.amplitude.form_location,
                    amplitudeLeadFormEventTracking: tracking.amplitude
                });
                return;
            }

            if (isApplicationModalOpenTrackingWithAmplitude(tracking)) {
                handleOpenModal({
                    clickText: tracking.gtm.clickText,
                    source: tracking.gtm.source,
                    amplitudeLeadFormEventTracking: tracking.amplitude,
                    gtmEventLeadForm: tracking.gtm
                });
                return;
            }

            if (isGtmEventLeadForm(tracking)) {
                const amplitudeTrackingContext = getAmplitudeCtaLeadFormTrackingContext({
                    source: openModalPayload.source,
                    sourceSection: openModalPayload.sourceSection,
                    leadData: undefined,
                    ctaText: tracking.clickText,
                    offerId: openModalPayload.offerId,
                    propertyId: openModalPayload.propertyId,
                    viewType
                });

                handleOpenModal({
                    clickText: tracking.clickText,
                    source: tracking.source,
                    amplitudeLeadFormEventTracking: amplitudeTrackingContext,
                    gtmEventLeadForm: tracking
                });
            }
        },
        [handleOpenModal, openModalPayload.offerId, openModalPayload.propertyId, openModalPayload.source, openModalPayload.sourceSection, viewType]
    );

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
